export default {
  "root": "_root_33w5n_1",
  "--bleed": "_--bleed_33w5n_1",
  "--bleed-true--m": "_--bleed-true--m_33w5n_1",
  "--bleed-false--m": "_--bleed-false--m_33w5n_1",
  "--bleed-true--l": "_--bleed-true--l_33w5n_1",
  "--bleed-false--l": "_--bleed-false--l_33w5n_1",
  "--bleed-true--xl": "_--bleed-true--xl_33w5n_1",
  "--bleed-false--xl": "_--bleed-false--xl_33w5n_1"
};import "ni:sha-256;MB9wMOxPkcN7f_n4sgQYev3ZlKdl6GxemKo8dW_KYzQ";